import {Endpoint, EndpointBuilder, hostname} from './Routes';
import {ResourceDto} from '@/Teams';

// --------------- /project/create ---------------
export interface ProjectCreateArgs {
  teamRefid: string;
  filename: string;
  templateId?: string;
  resources: ResourceDto[];
}

const projectCreateEndpointBuilder = new EndpointBuilder<ProjectCreateArgs>('/p/create');
projectCreateEndpointBuilder.method = 'POST';
projectCreateEndpointBuilder.jsonBody = true;
export const ProjectCreate = projectCreateEndpointBuilder.build();

// --------------- /project/lock ---------------
export interface ProjectLockArgs {
  projectRefid: string;
  expirationPeriodSeconds: number;
}

export const ProjectLock = new Endpoint<ProjectLockArgs>('/p/lock', 'POST');

// --------------- /project/remove ---------------
export interface ProjectRemoveArgs {
  projectRefid: string;
}

export const ProjectRemove = new Endpoint<ProjectRemoveArgs>('/p/remove', 'POST');

// --------------- /project/revert ---------------
export interface ProjectRevertArgs {
  projectRefid: string;
  generation: number;
}

export const ProjectRevert = new Endpoint<ProjectRevertArgs>('/p/revert', 'POST');

// --------------- /project/update ---------------
export interface ProjectUpdateArgs {
  projectRefid: string;
  filename: string;
}

export const ProjectUpdate = new Endpoint<ProjectUpdateArgs>('/p/writemeta', 'POST');

// --------------- /project/upload ---------------
export interface ProjectUpload {
  teamRefid: string;
  filename: string;
  encodedContent: string;
}

export const ProjectUpload = new Endpoint<ProjectUpload>('/p/upload', 'POST', hostname, 80, false);

// --------------- /project/unlock ---------------
export interface ProjectUnlockArgs {
  projectRefid: string;
}

export const ProjectUnlock = new Endpoint<ProjectUnlockArgs>('/p/unlock', 'POST');

// --------------- /project/versions ---------------
export interface ProjectVersionsArgs {
  projectRefid: string;
  startVersion?: number;
}

export const ProjectVersions = new Endpoint<ProjectVersionsArgs>('/p/versions', 'GET');

// ------------- /p/chart/get ------------------
export interface ProjectGanttChartArgs {
  projectRefid: string;
}
export const ProjectGanttChart = new Endpoint<ProjectGanttChartArgs>('/p/chart/get', 'GET');
